<template>
  <div class="offer-info">
    <!-- Location configuration -->
    <v-modal :modalName="modalName" class="offer-info__container">
      <template slot="header">
        <div class="offer-info__container__header">
          <v-img :src="createImageUrl(offer)" class="offer-info__container__header__offer-img" />
          <v-btn
            text
            large
            fab
            @click="toggleInfoModal()"
            class="offer-info__container__header--close"
          >
            <font-awesome-icon icon="times" />
          </v-btn>
        </div>
      </template>

      <template slot="body">
        <div class="offer-info__container__body">
          <div class="offer-info__container__body__entity">
            <v-img
              :src="createMerchantUrl(offer)"
              class="offer-info__container__body__entity--logo"
            />
            <span class="offer-info__container__body__entity--title">{{offer.merchant.name}}</span>
          </div>
          <div class="offer-info__container__body content">
            <div class="offer-info__container__body__row">
              <div class="offer-info__container__body__row__left">
                <span>Offer</span>
              </div>
              <div class="offer-info__container__body__row__right">
                <input type="text" :value="offer.title" class="input" />
              </div>
            </div>
            <v-divider />
            <div class="offer-info__container__body__row">
              <div class="offer-info__container__body__row__left">
                <span>Description</span>
              </div>
              <div class="offer-info__container__body__row__right">
                <textarea
                  :value="offer.merchant.description"
                  rows="1"
                  cols="40"
                  class="text-field"
                />
              </div>
            </div>
            <v-divider />
            <div class="offer-info__container__body__row">
              <div class="offer-info__container__body__row__left">
                <span>Tagline</span>
              </div>
              <div class="offer-info__container__body__row__right">
                <input type="text" :value="offer.tagline" class="input" />
              </div>
            </div>
            <v-divider />
            <div class="offer-info__container__body__row">
              <div class="offer-info__container__body__row__left">
                <span>Phone</span>
              </div>
              <div class="offer-info__container__body__row__right">
                <input
                  v-if="offer.merchant.number"
                  type="text"
                  :value="offer.merchant.phones[0].number"
                  class="input"
                />
                <input v-else type="text" placeholder="+44" class="input" />
              </div>
            </div>
            <div class="offer-info__container__body__row">
              <div class="offer-info__container__body__row__left">
                <span>Location(s) {{offer.applies.length}}</span>
              </div>
              <div class="offer-info__container__body__row__right"></div>
              <v-btn @click="locationConfig = !locationConfig">Change</v-btn>
            </div>
            <v-divider />
            <div class="offer-info__container__body__row">
              <div class="offer-info__container__body__row__left">
                <span>Tagline</span>
              </div>
              <div class="offer-info__container__body__row__right">
                <input type="text" :value="offer.tagline" class="input" />
              </div>
            </div>
            <div class="offer-info__container__body__row">
              <div class="offer-info__container__body__row__left">
                <span>Tagline</span>
              </div>
              <div class="offer-info__container__body__row__right">
                <input type="text" :value="offer.tagline" class="input" />
              </div>
            </div>
          </div>
        </div>
        <div id="slider" class="slide-down">
          <div class="location-config"></div>
        </div>
      </template>

      <template slot="footer">
        <div class="offer-info__container__footer">
          <v-btn text fab @click="createMerchant" class="check">
            <font-awesome-icon icon="check" />
          </v-btn>
        </div>
      </template>
    </v-modal>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import VModal from "@/components/VModal";
export default {
  components: {
    VModal
  },

  data() {
    return {
      modalName: "offer-info",

      offer: {},

      locationConfig: false
    };
  },

  methods: {
    ...mapActions({
      toggleInfoModal: "ui/infoModalState"
    }),

    createImageUrl(offer) {
      return `${process.env.VUE_APP_IMAGE_URL}/offer/${offer.id}_${offer.image}`;
    },

    createMerchantUrl(offer) {
      return `${process.env.VUE_APP_IMAGE_URL}/merchant/${offer.merchant.id}_${offer.merchant.logo}`;
    }
  },

  computed: {
    ...mapState({
      offers: state => state.offers
    })
  },

  watch: {
    locationConfig: function(val) {
      let el = document.querySelector("#slider");
      val
        ? el.classList.add("slide-up")
        : el.classList.remove("slide-up").add("slide-down");
    }
  },

  mounted() {
    this.offer = this.offers.offer;
  }
};
</script>

<style lang="sass" scoped>
@import @/styles/variables.sass
@import @/styles/mixins.sass
@import @/styles/base.sass

.offer-info
  position: fixed
  width: 100%
  height: 100%
  left: 0
  top: 0
  display: flex
  flex-flow: column
  justify-content: center
  backdrop-filter: blur(4px)
  background: rgba($c-black, .3)
  z-index: 100

  &__container
    max-height: 100%
    width: 420px
    transform: scale(.8)
    border-radius: 15px
    box-shadow: -2px -1px 5px rgba(0, 0, 0, .3)
    overflow-y: auto
    overflow-x: hidden !important

    @include for-size(phone-only)
      transform: scale(.8)

    &__header
      display: flex
      justify-content: center

      &__offer-img
        border-top:
          left-radius: 15px
          right-radius: 15px

      &--close
        position: absolute
        top: -10px
        left: 360px
        transition: .3s color ease

        &:hover
          color: $c-white

    // BODY
    &__body
      display: flex
      flex-flow: column

      &__entity
        display: flex
        flex-flow: column
        justify-content: center
        align-items: center
        
        &--logo
          position: absolute
          top: -30px
          transform: scale(.15)
          border-radius: 50%
          margin: 10px

        &--title
          height: 40px
          font:
            size: 15px
            weight: 400
          margin: 15px
          margin-left: 25px


      &__row
        display: flex
        flex-flow: row
        justify-content: space-between
        padding: 10px

        &__left
          padding-top: 10px

    &__footer
      display: flex
      justify-content: center

.input
  border: none

.text-field
  border: none
  border-radius: 0

.content 
  width: 100%
  height: 100%
  box-shadow: 0px -3px 3px rgba(0, 0, 0, .1)

.offer-data
  position: absolute
  left: 80px

.location-config
  background-color: #000

#slider

.slide-up
  max-height: 1000px
  width: 100px
  background: #000
  overflow-y: hidden
  -webkit-transition: max-height 0.5s ease-in-out
  -moz-transition: max-height 0.5s ease-in-out
  -o-transition: max-height 0.5s ease-in-out
  transition: max-height 0.5s ease-in-out

.slide-down
  max-height: 0
</style>